import { render, staticRenderFns } from "./position.vue?vue&type=template&id=0a450b3d&scoped=true&"
import script from "./position.vue?vue&type=script&lang=js&"
export * from "./position.vue?vue&type=script&lang=js&"
import style0 from "./position.vue?vue&type=style&index=0&lang=less&"
import style1 from "./position.vue?vue&type=style&index=1&id=0a450b3d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a450b3d",
  null
  
)

export default component.exports